(() => {
  'use strict';
  if (window.__dacWishlistEvents) return;
  window.__dacWishlistEvents = true;
  const sent = new Set();
  let previousCart = Array.isArray(window.DACWishlistCart) ? window.DACWishlistCart : window.DACWishlistCart?.items || [];
  function allowed() {
    try {
      const privacy = window.Shopify?.customerPrivacy;
      return privacy?.analyticsProcessingAllowed() === true && privacy?.marketingAllowed() === true;
    } catch (_) { return false; }
  }
  function product(item, et, quantity) {
    const epi = item.variant_id || item.epi || item.id;
    const empi = item.product_id || item.empi;
    if (!/^\d+$/.test(String(epi)) || !/^\d+$/.test(String(empi))) return null;
    let du;
    try { du = new URL(item.url || item.du, location.origin).href; } catch (_) { return null; }
    return {et, epi, empi, du, ...(item.product_title || item.dt ? {dt:item.product_title || item.dt}:{}),
      ...(item.image || item.iu ? {iu:new URL(item.image || item.iu, location.origin).href}:{}),
      ...(Number.isFinite(item.price) ? {pr:item.price / 100}:Number.isFinite(item.pr)?{pr:item.pr}:{}),
      ...(Number.isInteger(quantity) && quantity > 0 ? {qty:quantity}:{})};
  }
  function collect(event) {
    if (!event || !allowed() || !window.DACWishlist?.collectEvent) return;
    window.DACWishlist.collectEvent(event).catch(() => {});
  }
  function view() {
    if (!allowed()) return;
    const selected = window.DACWishlist?.currentProduct?.();
    const page = selected?.empi ? selected : window.SwymPageData;
    const query = new URLSearchParams(location.search);
    const shared = /\/pages\/[^/]*wishlist[^/]*\/?$/.test(location.pathname) && (query.has('lid') || query.has('hkey'));
    if (!page && !shared) return;
    const event = shared ? {et:14,du:location.origin+location.pathname+'?shared=1',dt:document.title} : page.et === 2 ? {et:2,dt:page.dt,du:page.du,...(page.iu?{iu:page.iu}:{})} : product(page,1);
    if (!event) return;
    const key = JSON.stringify([event.et,event.empi,event.epi,event.du]);
    if (sent.has(key)) return; sent.add(key); collect(event);
  }
  document.addEventListener('visitorConsentCollected',view);
  document.addEventListener('dac:cart-add-success',event => {
    for (const item of event.detail?.items || []) collect(product(item,3,Number(item.quantity)));
  });
  document.addEventListener('theme:cart',event => {
    const items = event.detail?.items;
    if (!Array.isArray(items)) return;
    const before = new Map(); const after = new Map();
    for (const item of previousCart) {const key=String(item.variant_id||item.id);before.set(key,{item,quantity:(before.get(key)?.quantity||0)+Number(item.quantity||0)});}
    for (const item of items) {const key=String(item.variant_id||item.id);after.set(key,(after.get(key)||0)+Number(item.quantity||0));}
    for (const [key,value] of before) {const removed=value.quantity-(after.get(key)||0);if(removed>0)collect(product(value.item,7,removed));}
    previousCart = items.map(item=>({...item}));
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',view,{once:true}); else view();
})();
